ACC.quickOrder = {
  invalidProdDiv: 'ph-invalidproductdiv',
  placeHolderProd: 'ph-quickorders__prodplaceholder',
  catalogIdName: 'catalogId',
  isSpCatalogCart: 'isSpCatalogCart',
  quickOrderForm: 'quickOrderForm',
  addRowClass: '.ph-quickorder__addrow',
  nullRowClass: '.ph-nullrow',
  rowCountClass: '.ph-quickorders__rowcount',
  rowsClass: '.ph-quickorders__rows',
  focusing: 'ph-focusing',
  dataemptyCart: 'data-emptyCart',
  spinnerOrderClass: '.ph-spinnerorder',
  incorrectFileMsgClass: '.ph-importorder_incorrectfilemsg',
  convertedDataHolderClass: '.convertedDataHolder',
  isOneStoreFlagEnabledClass: '.isOneStoreFlagEnabled',
  importOrderUploadFileClass: '.ph-importorders__uploadfile',
  productvalueInput: '.ph-quickorders__productvalue',
  quickOrderEntries: [],
  bindAll: function() {
    var prodCodeArray = [],
        inputQtyClass = 'ph-quickorders__qtyplaceholder input',
        prodRowId = [],
        invalidProdDiv = ACC.quickOrder.invalidProdDiv,
        prevVal = '';

    $('.' + inputQtyClass).unbind();

    ACC.quickOrder.focusQty();

    $(document).on('click', '.ph-importorders__togglelink', function() {
      $('.ph-togglequick').removeClass('hidden');
      $('.ph-importorderparent').addClass('hidden');
    });
    $(document).on('click', ACC.quickOrder.addRowClass, function() {
      $(ACC.quickOrder.nullRowClass).remove();

      var rowAddCount = parseInt($(ACC.quickOrder.rowCountClass).val(), 10),
          addIndex = rowAddCount + 1,
          placeholderafter = '.ph-quickorders__placeholderafter',
          dataplaceholder = 'data-placeholder',
          newRow = '<div class="ph-quickorders__rows ph-d-flex ph-flex-wrap ph-col-12 ph-p-0">' +
          '<div class="ph-quickorders__prodplaceholder ph-col-6 ph-col-md-7  ph-col-lg-4 ph-p-0" ' +
          'data-placeholder="' + $(placeholderafter).attr(dataplaceholder) + '"><input id="productCode-' + addIndex + '" name="productCode-' + addIndex +
          '" class="ph-quickorders__productvalue ph-forminput product_id ph-w-100 ph-m-0 ph-p-0 ph-px-2" placeholder="placeholder" />' +
          '<label class="ph-formlabel ph-product-code-label" for="productCode-' + addIndex + '">' + $(placeholderafter).attr(dataplaceholder) + '</label>' +
          '<input id="productCatalog-' + addIndex + '" name="productCatalog-' + addIndex + '" class="prod_catalog" type="hidden" value="" />' +
          '<p class="ph-order-status-icon ph-icon-close ph-quickorder hidden"></p><span class="ph-exclamation-mark"></span>' +
          '<p class="ph-order-status-icon ph-icon-checkmark ph-quickorders__tickicon hidden"></p></div>' +
          '<div class="ph-quickorders__qtyplaceholder ph-col-4  ph-col-md-3 ph-col-lg-2 ph-ml-1 ph-p-0"><input id="quantity-' + addIndex + '" name="quantity-' + addIndex +
          '" class="ph-quickorder__quantity ph-forminput product_quantity ph-w-100 ph-p-0 ph-m-0" placeholder="placeholder" maxlength="4"/>' +
          '<span class="ph-exclamation-mark"></span><label class="ph-formlabel ph-product-code-label ph-pr-0" for="quantity-' + addIndex +
          '">' + $(placeholderafter).attr('data-qty') + '</label></div><div class="ph-icon-trashbin ph-quickorder ph-col-1 ph-m-0 ph-ml-lg-2"></div>' +
          '<div class="ph-clearfix"></div><div class="ph-prodcodeinvalid ph-col-12 ph-col-lg-6 ph-px-0 ph-py-1 ph-mr-lg-4"></div>' +
          '<div class="ph-prodqtyinvalid ph-col-12 ph-col-lg-6 ph-px-0 ph-py-1"></div></div>';

      $('.ph-quickorders__addrowparent').before(newRow);
      $(ACC.quickOrder.rowCountClass).val(addIndex);
      $('.' + inputQtyClass).unbind();

      if (navigator.appVersion.indexOf('Edge') !== -1) {
        $('.ph-formlabel').addClass('ph-formlabeledge');
      }

      ACC.quickOrder.focusQty();

      $(ACC.quickOrder.rowsClass).find('input, textarea, select').focus(function() {
        $(this).parent().addClass(ACC.quickOrder.focusing);
      }).blur(function() {
        $(this).parent().removeClass(ACC.quickOrder.focusing);
      });
    });

    $('#getFile').change(function() {
      var fileName = $('#getFile')[0].files[0].name,
          regex = /^([a-zA-Z()0-9\s_\\.\-:])+(.csv|.xls)$/;

      $('.ph-importorderparent__choosetext').html(fileName);

      if (regex.test(fileName)) {
        $(ACC.quickOrder.incorrectFileMsgClass).addClass('hidden');
        ACC.quickOrder.dataExtractfromCSV();
      } else {
        $(ACC.quickOrder.incorrectFileMsgClass).removeClass('hidden hiddenClass');
        $(ACC.quickOrder.convertedDataHolderClass).text('');
      }
    });

    $(document).on('click', '.ph-icon-trashbin.ph-quickorder', function() {
      var rowRemoveCount = parseInt($(ACC.quickOrder.rowCountClass).val(), 10),
          minusIndex = rowRemoveCount - 1,
          $parent = $(this).parents('.ph-quickorders__rows,.ph-quickorders__mobilerows');

      $parent.remove();
      $(ACC.quickOrder.rowCountClass).val(minusIndex);
      $('.' + inputQtyClass).unbind();
      ACC.quickOrder.focusQty();

      if (parseInt($(ACC.quickOrder.rowCountClass).val(), 10) === 0 || $('#' + ACC.quickOrder.quickOrderForm).find('.ph-verified').length === 0) {
        $('#' + ACC.quickOrder.catalogIdName).val($('#' + ACC.quickOrder.catalogIdName).attr('existingCartCatalogId'));
        ACC.quickOrder.checkSpCatalog($('#' + ACC.quickOrder.catalogIdName).val());
        prevVal = '';
        $('#' + ACC.quickOrder.quickOrderForm).find('.ph-quickorders__productvalue:first').trigger('blur');
      }

      ACC.quickOrder.updateProdSession('');
    });

    $(document).on('mousedown', '.ph-quickorders__clearall', function() {
      $('#' + ACC.quickOrder.catalogIdName).val($('#' + ACC.quickOrder.catalogIdName).attr('existingCartCatalogId'));
      ACC.quickOrder.checkSpCatalog($('#' + ACC.quickOrder.catalogIdName).val());
      $(ACC.quickOrder.rowCountClass).val('0');
      $('.ph-togglequick>.ph-quickorders__rows').remove();
      $(ACC.quickOrder.addRowClass).trigger('click');
      ACC.quickOrder.updateProdSession('');
    });

    $(document).on('click', '.ph-quickorders__togglelink', function() {
      $('#' + ACC.quickOrder.catalogIdName).val($('#' + ACC.quickOrder.catalogIdName).attr('existingCartCatalogId'));
      ACC.quickOrder.checkSpCatalog($('#' + ACC.quickOrder.catalogIdName).val());

      if ($('#' + ACC.quickOrder.isSpCatalogCart).val() === 'true') {
        $('#importcatalogSpareParts').prop('checked', true);
      } else {
        $('#importcatalogConsumables').prop('checked', true);
      }

      $('.ph-importcatalog_mixcartmsg').addClass('hidden');
    });

    $(document).on('click', '.ph-importcatalog_radios', function() {
      if ($('#' + ACC.quickOrder.catalogIdName).val() === $(this).val()) {
        $('.ph-importcatalog_mixcartmsg').addClass('hidden');
      } else if ($('#' + ACC.quickOrder.catalogIdName).val() !== '') {
        $('.ph-importcatalog_mixcartmsg.ph-info_negative').removeClass('hidden hiddenClass');
      }
    });

    $(document).on('focus', ACC.quickOrder.productvalueInput, function() {
      prodCodeArray = [];
      prodRowId = [];
      prevVal = $(this).val();

      var productIdClass = '.product_id';

      $(ACC.quickOrder.rowsClass).each(function() {
        if (!$(this).find('.' + ACC.quickOrder.placeHolderProd).hasClass(invalidProdDiv)) {
          prodCodeArray.push($(this).find(productIdClass).val());

          if ($(this).find(productIdClass).val() !== '' && typeof $(this).find(productIdClass).val() !== 'undefined') {
            prodRowId.push($(this).find(productIdClass).attr('id'));
          }
        }
      });

      $('.ph-quickordercontainer .ph-info_negative').addClass('hiddenClass');
    }).on('blur', ACC.quickOrder.productvalueInput, function() {
      var prodObject = {},
          $row = $(this).closest(ACC.quickOrder.rowsClass),
          prodCode = $(this).val();

      ACC.quickOrder.updateObjProps(prodObject, $row, prodCode);
      ACC.quickOrder.inputBlurActivity(prodObject);

      if (prodObject.$prodCode === '') {
        ACC.quickOrder.productFailed(prodObject, 'emptycode');
      } else if (prevVal !== prodObject.$prodCode) {
        ACC.quickOrder.productAjaxCall(prodObject);
      }
    });

    $(document).on('blur', '.ph-quickorder__quantity', function() {
      var $row = $(this).closest(ACC.quickOrder.rowsClass),
          prodQty = $(this).val();

      var prodObject = {
        $productParent: $row.find('.ph-quickorders__qtyplaceholder'),
        $errorField: $row.find('.ph-prodqtyinvalid')
      };

      if (prodQty === '' || prodQty <= 0) {
        ACC.quickOrder.qtyFailed(prodObject, 'emptyqty');
      } else if (isNaN(prodQty)) {
        ACC.quickOrder.qtyFailed(prodObject, 'notNumber');
      } else {
        ACC.quickOrder.qtySuccess(prodObject);
        ACC.quickOrder.updateProdQtySession({
          prodCode: $row.find('.product_id.ph-quickorders__productvalue').val(),
          prodQty: prodQty
        });
      }
    });
    $(document).on('keydown', '#quickOrderForm', function(keyevent) {
      if (keyevent.keyCode === 13) {
        $('.ph-addtoquickordercart').trigger('click');
        keyevent.preventDefault();
      }
    });
  },
  updateObjProps: function(prodObject, $row, prodCode) {
    prodObject.$productParent = $row.find('.' + ACC.quickOrder.placeHolderProd);
    prodObject.$prodCode = prodCode;
    prodObject.$prodTitle = prodObject.$productParent.find('.ph-formlabel');
    prodObject.$prodQty = $row.find('.product_quantity').val();
    prodObject.$errorField = $row.find('.ph-prodcodeinvalid');
    prodObject.$prodCross = prodObject.$productParent.find('.ph-icon-close.ph-quickorder');
    prodObject.$prodExclamation = prodObject.$productParent.find('.ph-exclamation-mark');
    prodObject.$prodCheck = prodObject.$productParent.find('.ph-icon-checkmark');
    prodObject.$placeholder = prodObject.$productParent.attr('data-placeholder');
  },
  productAjaxCall: function(prodObject) {
    var ajaxData = {},
        ajaxUrl = $('#getProductTitleUrl').text().replace(/\s+/g, '');

    if ($(ACC.quickOrder.isOneStoreFlagEnabledClass).text() === 'true') {
      ajaxUrl = $('#getProductTitleOSUrl').text().replace(/\s+/g, '');
      ajaxData = {
        productCode: prodObject.$prodCode
      };
    } else {
      ajaxData = {
        productCode: prodObject.$prodCode,
        catalogId: prodObject.$catalogId
      };
    }

    $.ajax({
      url: ajaxUrl,
      type: 'GET',
      data: ajaxData,
      success: function(result) {
        var invalidcode = 'invalidcode';

        if (result) {
          if (result.errorMessage) {
            ACC.quickOrder.errorMsgKeys(prodObject, result.errorMessage);
          } else if (result.catalogId && result.productName) {
            ACC.quickOrder.productSuccess(prodObject, result);
            ACC.quickOrder.updateProdSession({
              prodCode: prodObject.$prodCode,
              prodQty: prodObject.$prodQty,
              prodResult: result
            });
          } else {
            ACC.quickOrder.productFailed(prodObject, invalidcode);
          }
        } else {
          ACC.quickOrder.productFailed(prodObject, invalidcode);
        }
      },
      error: function() {
        ACC.quickOrder.productFailed(prodObject, 'invalidcode');
      }
    });
  },
  errorMsgKeys: function(prodObject, errorMessage) {
    if (errorMessage === 'text.addToCart.error.duplicateProduct.message') {
      ACC.quickOrder.productFailed(prodObject, 'duplicateproduct');
    } else if (errorMessage === 'text.cart.conflict.message') {
      ACC.quickOrder.productFailed(prodObject, 'invalidcatalog');
    } else {
      ACC.quickOrder.productFailed(prodObject, 'invalidcatalog');
    }
  },
  focusQty: function() {
    $('.ph-quickorders__qtyplaceholder input').last().focus(function() {
      $(ACC.quickOrder.addRowClass).trigger('click');
    });
  },
  inputBlurActivity: function(prodObject) {
    prodObject.$productParent.removeClass('ph-verified');

    if ($('#' + ACC.quickOrder.quickOrderForm).find('.ph-verified').length === 0) {
      $('#' + ACC.quickOrder.catalogIdName).val($('#' + ACC.quickOrder.catalogIdName).attr('existingCartCatalogId'));
    }

    prodObject.$catalogId = $('#' + ACC.quickOrder.catalogIdName).val();
  },
  changeAcknowledgePopup: function($item) {
    var incidentNumber = $('.ph-incidentNumberSSO').html();

    if (ACC.orderReason.$isssoLogin === 'true' && incidentNumber !== ' ') {
      ACC.quickOrder.setQuickOrderEntries([]);
      $($item).submit();
    } else {
      $.colorbox({
        html: $('.ph-acknowledge-selector').html(),
        width: '100%',
        maxWidth: 540,
        maxHeight: '90%',
        fixed: true,
        close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
        onComplete: function() {
          ACC.common.refreshScreenReaderBuffer();

          $(ACC.quickOrder.spinnerOrderClass).hide();
          $(document).on('click', '.ph-acknowledge_button a', function() {
            $.colorbox.close();
          });

          $(document).on('click', '.ph-acknowledge-continue', function() {
            $(ACC.quickOrder.spinnerOrderClass).show();
            ACC.quickOrder.setQuickOrderEntries([]);
            $($item).submit();
            $.colorbox.close();
          });
        },
        onClosed: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    }
  },
  resetCallback: function() {
    return false;
  },
  addremove: function(obj) {
    obj.$errorField.addClass('ph-wrongprod');
    obj.$prodCross.removeClass('hidden ph-crossemptycode ph-crossinvalidcatalog');
    obj.$prodExclamation.addClass('hidden');
    obj.$prodExclamation.removeClass('ph-exclamationemptycode ph-exclamationinvalidcode ph-exclamationinvalidcatalog');
  },
  productFailed: function(obj, item) {
    var invalidProdDiv = ACC.quickOrder.invalidProdDiv;

    ACC.quickOrder.addremove(obj);
    obj.$errorField.html($('.ph-errormessages').attr('data-' + item)).addClass('ph-wrongprod');
    obj.$prodTitle.html(obj.$placeholder);
    obj.$prodCheck.addClass('hidden');
    obj.$prodCross.removeClass('hidden');
    obj.$prodCross.addClass('ph-cross' + item);
    obj.$productParent.addClass(invalidProdDiv);
    obj.$prodExclamation.addClass('ph-exclamation' + item);
    obj.$productParent.find('.prod_catalog').val('');
  },
  checkSpCatalog: function(catalogId) {
    if (catalogId && catalogId.indexOf('SpareParts') > -1) {
      $('#' + ACC.quickOrder.isSpCatalogCart).val('true');
    } else {
      $('#' + ACC.quickOrder.isSpCatalogCart).val('false');
    }
  },
  productSuccess: function(obj, result) {
    if (result.productName) {
      obj.$prodTitle.html(result.productName.split('"').join(''));
    }

    if (result.catalogId) {
      obj.$productParent.addClass('ph-verified');
      $('#' + ACC.quickOrder.catalogIdName).val(result.catalogId);
      ACC.quickOrder.checkSpCatalog(result.catalogId);

      if ($(ACC.quickOrder.isOneStoreFlagEnabledClass).text() === 'true') {
        obj.$productParent.find('.prod_catalog').val(result.catalogId);
      }
    }

    var invalidProdDiv = ACC.quickOrder.invalidProdDiv;

    obj.$errorField.html('').removeClass('ph-wrongprod');
    // Commeted this existing code :  obj.$prodTitle.html(result.split('"').join(''));
    obj.$prodCheck.removeClass('hidden');
    obj.$prodCross.addClass('hidden');
    obj.$productParent.removeClass(invalidProdDiv);
  },
  qtyFailed: function(obj, item) {
    var invalidProdDiv = ACC.quickOrder.invalidProdDiv;

    obj.$errorField.html($('.ph-errormessages').attr('data-' + item)).addClass('ph-wrongprod');
    obj.$productParent.addClass(invalidProdDiv);
  },
  qtySuccess: function(obj) {
    var invalidProdDiv = ACC.quickOrder.invalidProdDiv;

    obj.$errorField.html('').removeClass('ph-wrongprod');
    obj.$productParent.removeClass(invalidProdDiv);
  },
  dataExtractfromCSV: function() {
    if (typeof FileReader !== 'undefined') {
      var reader = new FileReader();

      reader.onload = function(e) {
        var rows = e.target.result.split('\n');
        var arrayOfObj = [];

        for (var i = 1; i < rows.length; i = i + 1) {
          var cells = rows[i].split(',');

          if (cells.length > 1) {
            arrayOfObj.push(cells[0]);
          }
        }

        var dataArr = arrayOfObj.filter(function(el) {
          return el !== '';
        });

        var dataStr = dataArr.join(',');

        $(ACC.quickOrder.convertedDataHolderClass).text(dataStr);
      };
      reader.readAsText($('#getFile')[0].files[0]);
    }
  },
  spCheckCsvAjax: function() {
    var ajaxUrl = $('#importOrderVerifySPUrl').text(),
        ajaxData = $(ACC.quickOrder.convertedDataHolderClass).text();

    return $.get(ajaxUrl, {
      listProductId: ajaxData
    });
  },
  osCheck: function() {
    var regex = /^([a-zA-Z()0-9\s_\\.\-:])+(.csv|.xls)$/;

    if ($('#getFile')[0].files.length > 0 && !regex.test($('#getFile')[0].files[0].name)) {
      // Show error
      $(ACC.quickOrder.incorrectFileMsgClass).removeClass('hidden hiddenClass');
    } else if (ACC.product.checkForSpInCart() === false) {
      // False means there is SP product in cart
      $(ACC.quickOrder.importOrderUploadFileClass).submit();
    } else {
      var isSpInCsv = false,
          numfilesImported = $('#getFile')[0].files.length;

      $(ACC.quickOrder.spinnerOrderClass).show();

      if (numfilesImported === 0) {
        isSpInCsv = false;
        $(ACC.quickOrder.spinnerOrderClass).hide();
        ACC.quickOrder.spPopup(isSpInCsv);
      } else {
        ACC.quickOrder.spCheckCsvAjax().done(function(result) {
          isSpInCsv = result;
          $(ACC.quickOrder.spinnerOrderClass).hide();
          ACC.quickOrder.spPopup(isSpInCsv);
        });
      }
    }

    return false;
  },
  spPopup: function(isSpInCsv) {
    if (isSpInCsv === 'true' || isSpInCsv === true) {
      ACC.quickOrder.changeAcknowledgePopup($(ACC.quickOrder.importOrderUploadFileClass));
    } else {
      $(ACC.quickOrder.importOrderUploadFileClass).submit();
    }
  },
  osAcknowledgePopupEnabled: function() {
    var showAcknowledgePopup = 'false';

    if (ACC.product.checkForSpInCart()) {
      $(ACC.quickOrder.rowsClass).find('input.prod_catalog').each(function() {
        if ($(this).val().indexOf('SpareParts') > -1) {
          showAcknowledgePopup = 'true';
        }
      });
    }

    return showAcknowledgePopup;
  },
  validateQuickOrder: function(data) {
    var isValid = true,
        $quickOrderForm = $('#quickOrderForm');

    if (data.$row.length > 0) {
      $(ACC.quickOrder.nullRowClass).remove();
      data.$row.each(function() {
        ACC.quickOrder.validateqo($(this));
      });
    } else {
      var nullrow = '<div class="ph-nullrow">' + $('.ph-errormessages').attr('data-nullrow') + '</div>';

      $('.ph-quickorders__addrowparent').before(nullrow);
    }

    if ($('.ph-invalidproductdiv').length > 0 || $(ACC.quickOrder.nullRowClass).length > 0) {
      isValid = false;
    }

    if (isValid) {
      if ($('#isOneStoreFlagEnabled').text() === 'true' && ACC.quickOrder.osAcknowledgePopupEnabled() === 'true') {
        ACC.quickOrder.changeAcknowledgePopup($quickOrderForm);
      } else if ($('#isOneStoreFlagEnabled').text() !== 'true' &&
       $('#' + ACC.quickOrder.isSpCatalogCart).val() === 'true' && data.clearCartFlag === 'true') {
        ACC.quickOrder.changeAcknowledgePopup($quickOrderForm);
      } else {
        ACC.quickOrder.setQuickOrderEntries([]);
        $quickOrderForm.submit();
      }
    } else {
      $(ACC.quickOrder.spinnerOrderClass).hide();
    }
  },
  validateqo: function($row) {
    var valid = true,
        trimmedProduct = $.trim($($row).find('.product_id').val()),
        trimmedQty = $.trim($($row).find('.product_quantity').val());

    if (trimmedProduct !== '') {
      if (trimmedQty === '') {
        valid = ACC.quickOrder.showError($row, 'quantity');
      }
    } else if (trimmedQty !== '') {
      if (trimmedProduct === '') {
        valid = ACC.quickOrder.showError($row, 'product');
      }
    } else if (trimmedProduct === '' && trimmedQty === '') {
      $($row).find('.ph-invalidproductdiv').removeClass('ph-invalidproductdiv');
    }

    return valid;
  },
  showError: function($row, item) {
    var invalidProdDiv = ACC.quickOrder.invalidProdDiv;

    if (item && item === 'quantity') {
      $row.find('.ph-prodqtyinvalid').addClass('ph-wrongprod').html($('.ph-errormessages').attr('data-emptyqty'));
      $row.find('.ph-quickorders__qtyplaceholder').addClass(invalidProdDiv);
    } else if (item && item === 'product') {
      $row.find('.ph-prodcodeinvalid').addClass('ph-wrongprod').html($('.ph-errormessages').attr('data-emptycode'));
      $row.find('.' + ACC.quickOrder.placeHolderProd).addClass(invalidProdDiv);
    }

    return false;
  },

  updateProdQtySession: function(rowEntry) {
    var sessionDataArray = ACC.quickOrder.quickOrderEntries;
    var revisedRowData = sessionDataArray.map(function(el) {
      if (rowEntry && rowEntry.prodCode === el.prodCode) {
        el.prodQty = rowEntry.prodQty;
      }

      return el;
    });

    ACC.quickOrder.setQuickOrderEntries(revisedRowData);
  },
  updateProdSession: function(newEntry) {
    var sessionDataArray = ACC.quickOrder.quickOrderEntries;

    var refinedArray = [],
        invalidProdDiv = ACC.quickOrder.invalidProdDiv,
        productIdClass = '.product_id.ph-quickorders__productvalue';

    $(ACC.quickOrder.rowsClass).each(function() {
      var prodCodetoSave = $(this).find(productIdClass).val();

      if (!$(this).find('.' + ACC.quickOrder.placeHolderProd).hasClass(invalidProdDiv) &&
       prodCodetoSave && refinedArray.indexOf(prodCodetoSave) === -1) {
        refinedArray.push(prodCodetoSave);
      }
    });

    var filteredRowData = sessionDataArray.filter(function(el) {
      if (newEntry && newEntry.prodCode === el.prodCode) {
        return false;
      }

      return refinedArray.indexOf(el.prodCode) > -1;
    });

    if (newEntry) {
      filteredRowData.push(newEntry);
    }

    ACC.quickOrder.setQuickOrderEntries(filteredRowData);
  },
  getQuickOrderEntries: function() {
    var quickOrderEntriesString = sessionStorage.getItem('quickOrderEntries');

    if (quickOrderEntriesString) {
      ACC.quickOrder.quickOrderEntries = JSON.parse(quickOrderEntriesString);
    } else {
      ACC.quickOrder.quickOrderEntries = [];
    }

    return ACC.quickOrder.quickOrderEntries;
  },
  setQuickOrderEntries: function(filteredRowData) {
    var quickOrderEntriesString = '';

    ACC.quickOrder.quickOrderEntries = [];

    if (filteredRowData.length > 0) {
      ACC.quickOrder.quickOrderEntries = filteredRowData;
      quickOrderEntriesString = JSON.stringify(filteredRowData);
    }

    sessionStorage.setItem('quickOrderEntries', quickOrderEntriesString);
  },
  retainEntries: function() {
    var sessionDataArray = ACC.quickOrder.getQuickOrderEntries(),
        rowItemNum = 1;

    $('.ph-quickorders__clearall').trigger('mousedown');

    if (sessionDataArray.length > 0) {
      sessionDataArray.forEach(function(sessionRowEntry) {
        var prodObjectNew = {},
            $rowInput = $('#productCode-' + rowItemNum),
            $row = $rowInput.closest(ACC.quickOrder.rowsClass);

        $rowInput.val(sessionRowEntry.prodCode);
        $row.find('.ph-quickorder__quantity').val(sessionRowEntry.prodQty);
        ACC.quickOrder.updateObjProps(prodObjectNew, $row, sessionRowEntry.prodCode);
        ACC.quickOrder.productSuccess(prodObjectNew, sessionRowEntry.prodResult);
        rowItemNum = rowItemNum + 1;
        $(ACC.quickOrder.addRowClass).trigger('click');
      });
      ACC.quickOrder.setQuickOrderEntries(sessionDataArray);
    }
  },
  getParameterByName: function(name) {
    var newurl = new URL(window.location.href);

    return newurl.searchParams.get(name);
  },
  formValidation: function() {
    $('#' + ACC.quickOrder.quickOrderForm).on('submit', function(event) {
      var validProducts = $('#' + ACC.quickOrder.quickOrderForm).find('.ph-quickorders__tickicon:visible').length,
          validProductsCount = 0;

      $($('#' + ACC.quickOrder.quickOrderForm).find('.' + ACC.quickOrder.placeHolderProd)).each(function() {
        if ($(this).find(ACC.quickOrder.productvalueInput).val()) {
          validProductsCount = validProductsCount + 1;
        } else {
          $(this).parent().remove();
        }
      });

      if (validProducts === 0 || validProducts !== validProductsCount) {
        $(ACC.quickOrder.spinnerOrderClass).hide();
        event.preventDefault();
      }
    });
  }
};

$(document).ready(function() {
  var ssoinvalid = ACC.quickOrder.getParameterByName('ssoInvalid');

  if (ssoinvalid === 'true') {
    $('.ph-salesInvalid').removeClass('hidden');
    $('.ph-middleContent').addClass('ph-carousel');
  } else {
    $('.ph-salesInvalid').addClass('hidden');
    $('.ph-middleContent').removeClass('ph-carousel');
  }


  if ($('.ph-page-quickOrder').length > 0) {
    $(document).on('submit', '.ph-importorders__uploadfile', function() {
      $(ACC.quickOrder.spinnerOrderClass).show();
    });
    ACC.quickOrder.bindAll();
    ACC.quickOrder.retainEntries();
    $(document).on('click', '.ph-icon-close.ph-quickorder-pop', function() {
      $('.ph-quickorders__text3').addClass('hidden');
    });
    $(document).on('click', '.ph-uploadfile', function() {
      if ($(ACC.quickOrder.isOneStoreFlagEnabledClass).text() === 'true') {
        ACC.quickOrder.osCheck();
      } else {
        $(ACC.quickOrder.spinnerOrderClass).show();

        var data = {
          clearCartFlag: $(this).attr(ACC.quickOrder.dataemptyCart)
        };

        if ($('#importcatalogSpareParts').is(':checked') && data.clearCartFlag === 'true') {
          ACC.quickOrder.changeAcknowledgePopup($(this).parents(ACC.quickOrder.importOrderUploadFileClass));
        } else {
          $(this).parents(ACC.quickOrder.importOrderUploadFileClass).submit();
        }
      }
    });
    $('#reorderButton_ignored').on('click', function() {
      var emptyCart = $(this).attr(ACC.quickOrder.dataemptyCart);

      if (emptyCart === 'true') {
        ACC.quickOrder.changeAcknowledgePopup($('#reorderForm'));
      } else {
        $('#reorderForm').submit();
      }
    });
    $('.ph-addtoquickordercart').on('click', function() {
      var data = {
        $row: $(ACC.quickOrder.rowsClass),
        clearCartFlag: $(this).attr(ACC.quickOrder.dataemptyCart)
      };

      $(ACC.quickOrder.spinnerOrderClass).show();
      ACC.quickOrder.validateQuickOrder(data);
    });
    $(document).on('click', '.ph-quickorders__togglelink span', function() {
      $('.ph-importorderparent').removeClass('hidden');
      $('.ph-togglequick').addClass('hidden');
      $('.ph-quickordercontainer .ph-info_negative').addClass('hiddenClass');
    });
    $(ACC.quickOrder.rowsClass).find('input, textarea, select').focus(function() {
      $(this).parent().addClass(ACC.quickOrder.focusing);
    }).blur(function() {
      $(this).parent().removeClass(ACC.quickOrder.focusing);
    });
    ACC.quickOrder.checkSpCatalog($('#' + ACC.quickOrder.catalogIdName).val());
    ACC.quickOrder.formValidation();
  }

  $(document).on('click', '.winRedirectLink', function() {
    if ($(this).attr('redirectLink')) {
      window.location.replace($(this).attr('redirectLink'));
    }
  });
});
